var map = {
	".": "C8jp",
	"./": "C8jp",
	"./00_limit": "/ur1",
	"./00_limit.json": "/ur1",
	"./01_connect": "wa9k",
	"./01_connect.json": "wa9k",
	"./02_data_compress": "vuQY",
	"./02_data_compress.json": "vuQY",
	"./03_heart_beat": "il07",
	"./03_heart_beat.json": "il07",
	"./04_subscribe": "n8XW",
	"./04_subscribe.json": "n8XW",
	"./05_cancel_subscribe": "7k03",
	"./05_cancel_subscribe.json": "7k03",
	"./index": "C8jp",
	"./index.js": "C8jp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GdCH";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/introduce ^.*$
// module id = GdCH
// module chunks = 3